import axios from "axios"

export default {
  state: {
   // selectedDoctor: {},
    doctors: JSON.parse(localStorage.getItem('doctors')) || null,
   // slctdDctr: this.selectedDoctor
  },
  getters: {
    selectedDoctor(state) {
      return state.doctors.doctors.find(
        doctor => doctor.doctorID === this.$route.params.id
      );
    }
  },
  mutations: {
    getAllDoctors(state, doctors) {
      state.doctors = doctors
      localStorage.setItem('doctors', JSON.stringify(doctors))

    },
    selectDoctor(state, doctor) {
      state.selectedDoctor = doctor
    },
    rejectDoctor(state, doctorId) {
      state.doctors[state.doctors.findIndex(doctor => doctor.doctorID === doctorId)].BORevisedStatus = 'rejected'
    },
    approveDoctor(state, doctorId) {
      state.doctors[state.doctors.findIndex(doctor => doctor.doctorID === doctorId)].BORevisedStatus = 'accepted'
    },
    blockDoctor(state, userId) {
      state.doctors[state.doctors.findIndex(doctor => doctor.userProfile.userId === userId)].userProfile.isBlocked = true
    },
    unblockDoctor(state, userId) {
      state.doctors[state.doctors.findIndex(doctor => doctor.userProfile.userId === userId)].userProfile.isBlocked = false
    },
    updateKad(state, credentials){
    //  console.log('before xaxa', state.slctdDctr)
      state.doctors.find(doctor => doctor.doctorID === credentials.id).KADs = credentials.kads
    //  console.log('xaxa',state.slctdDctr)
    }
  },
  actions: {
    getAllDoctors({ commit }, credentials) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        axios.get(`${process.env.VUE_APP_BASE_URL}admin/doctors/list`,
          {
            params:
            {
              pageSize: credentials.pageSize,
              pageNo: credentials.pageNo,
              activeStatus: credentials.activeStatus,
              sortBy: credentials.sortBy,
              dir: credentials.dir,
              prefecture: credentials.prefecture,
              municipality: credentials.municipality,
              search: credentials.search
            }
          })
          .then(res => {
            console.log(res.data)
            commit('getAllDoctors', res.data.results)
            commit('setLoading', false)
            resolve(res)
          })
          .catch(err => {
            commit('setLoading', false)
            localStorage.removeItem('doctors')
            reject(err)
            console.log(err.response)
          })
      })

    },
    selectDoctor({ commit }, doctor) {
      commit('selectDoctor', doctor)
    },
    rejectDoctor({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}admin/reviseDoctor`, credentials)
          .then(res => {
            console.log(res)
            commit('rejectDoctor', credentials.doctorId)
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    approveDoctor({ commit }, credentials) {

      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}admin/reviseDoctor`, credentials)
          .then(res => {
            console.log(res)
            commit('approveDoctor', credentials.doctorId)
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },

    blockDoctor({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}user/setBlock`, credentials)
          .then(res => {
            console.log(res)
            commit('blockDoctor', credentials.userId)
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    unblockDoctor({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}user/setBlock`, credentials)
          .then(res => {
            console.log(res)
            commit('unblockDoctor', credentials.userId)
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    updateKad({commit}, credentials){
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}system/boDoctorVatCheck`, {entityId: credentials.entityId, taxId: credentials.taxId})
        .then(res => {
          commit('updateKad', {kads: res.data.KADs, id: credentials.entityId})
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    setStandBy({commit}, doctor){
      console.log('is',doctor.isVideoCallStandBy)
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}admin/setDoctorVideoCallStandBy`, {doctorId: doctor.doctorID, isVideoCallStandBy: !!doctor.isVideoCallStandBy ? true : false})
        .then(res => {
          console.log(res)
         // commit('setStandBy',{id: doctor.doctorID, value: res})
          resolve()
        })
        .catch(err => {
          console.log(err)
          reject()
        })
      })
    }
  }
}